import React, {useEffect, useMemo, useState, useCallback} from 'react'
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonDataTable from '../../../components/CommonDataTable';

import HistoryIcon from '@mui/icons-material/History';

import {fetchHsn} from '../../../services/hsn/hsn';

const rawColumns = [

    { field: 'hsnCode', headerName: 'HSN Code', width: 130 },

    { field: 'description', headerName: 'Description', width: 200 },

    { 
        field: 'taxExempted', 
        headerName: 'Tax Exempted', 
        width: 140,
        renderCell: (params) => (params.value ? "Yes" : "No")
    },

    { field: 'cgstRate', headerName: 'CGST %', width: 100 },

    { field: 'sgstRate', headerName: 'SGST %', width: 100 },

    { field: 'igstRate', headerName: 'IGST %', width: 100 },

    { field: 'cessRate', headerName: 'Cess %', width: 100 },

    { field: 'effectiveTax', headerName: 'Effective Tax %', width: 150 },

    { field: 'effectiveFromDate', headerName: 'Effective From', width: 150 },

    { field: 'effectiveToDate', headerName: 'Effective To', width: 150 },

    { field: 'status', headerName: 'Status', width: 120 },

    // { field: 'createdBy', headerName: 'Created By', width: 130 },

    // { field: 'createdDate', headerName: 'Created Date', width: 180 },

    // { field: 'updatedBy', headerName: 'Updated By', width: 130 },

    // { field: 'updatedDate', headerName: 'Updated Date', width: 180 },
];


export default function Hsnlist({onCreateClick, refreshKey, onView, onEdit}) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [tableRows, setTableRows] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const loadHsnLis = useCallback(async (page, pageSize) => {
  try {
    const hsnData = await fetchHsn(page, pageSize);

    console.log("Fetched HSN Data:", hsnData);

    // support both shapes: API may return an array OR an object { data: [...], totalCount }
    const items = Array.isArray(hsnData) ? hsnData : (hsnData?.data || hsnData?.docs || []);

    if (items && items.length) {

      const formattedData = items.map(field => ({
        id: field._id,   // REQUIRED for DataGrid

        hsnId: field._id,

        hsnCode: field.hsnCode || field.HSNCode,  // handle both cases

        description: field.hsnDescription,

        taxExempted: field.taxExempted,

        cgstRate: field.cgstRate,
        sgstRate: field.sgstRate,
        igstRate: field.igstRate,
        cessRate: field.cessRate,
        effectiveTax: field.effectiveTax,

        status: field.status,

        createdBy: field.createdBy,
        updatedBy: field.updatedBy,
      }));


      setTableRows(formattedData);
      const total = hsnData?.pagination?.totalRecords ?? formattedData.length;
      setTotalCount(total);

    } else {
      setTableRows([]);
      setTotalCount(0);
    }

  } catch (error) {
    console.error('Error fetching HSN data:', error);
    setTableRows([]);
    setTotalCount(0);
  }
}, []);


console.log(totalCount, "totalCount");

  useEffect(() => {
    loadHsnLis(page, pageSize);
  }, [page, pageSize, refreshKey, loadHsnLis]);
      // ----------------- Menu handling -----------------
    const handleOpenMenu = (e, row) => {
        e.stopPropagation();
        setMenuAnchorEl(e.currentTarget);
        setMenuRow(row);
    };
    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

  const actionColumn = {
        field: "__actions",
        headerName: "",
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
            <IconButton
                size="small"
                onClick={(e) => handleOpenMenu(e, params.row)}
                aria-label="row actions"
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
        ),
    };

    const allPossibleColumns = useMemo(() => [actionColumn, ...rawColumns], []);
        const initialVisible = useMemo(
            () => allPossibleColumns.map((c) => c.field),
            [allPossibleColumns]
    );
  

  return (
     <>
                <CommonDataTable
                    allPossibleColumns={allPossibleColumns}
                    initialVisible={initialVisible}
                    initialRows={tableRows}
                    height={520}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    exportImportPath="InventoryLedger"
                    forItems
                    // showCreateButton={true}
                    // createButtonText="Create New"
                    createButtonIcon="bi-plus-lg"
                    onCreateClick={onCreateClick}
                    createButtonVariant="contained"
                    createButtonColor="primary"
                    page={page}
                    pageSize={pageSize}
                    rowCount={totalCount}
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newSize) => {
                        setPageSize(newSize);
                        setPage(0);
                    }}
                    onDataRefresh={async ({ filters = [], page: p = 0, pageSize: ps = pageSize } = {}) => {
    
                        console.log("ASN ....................... received onDataRefresh:", { filters, page: p, pageSize: ps });
    
                    }}
                />
    
                <Menu open={!!menuAnchorEl} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>
                    <MenuItem onClick={() => onView(menuRow)}>
                        <i className="bi bi-eye me-2" /> View
                    </MenuItem>
                    {/* <MenuItem onClick={() => onEdit(menuRow)}>
                        <i className="bi bi-pencil me-2" /> Edit
                    </MenuItem> */}
                </Menu>
            </>
  )
}
